module.exports = __webpack_public_path__ + "img/96.4b89bf03.jpg";